import React from "react";
import { Minus, Plus } from "lucide-react";

const QuantitySelector = ({ value, onChange }) => (
  <div className="flex items-center overflow-hidden rounded-[8px] border border-white/20">
    <button onClick={() => onChange(Math.max(1, value - 1))} className="min-h-[48px] px-4 hover:bg-white/10" aria-label="decrease">
      <Minus size={14} />
    </button>
    <span className="px-5 font-mono">{value}</span>
    <button onClick={() => onChange(value + 1)} className="min-h-[48px] px-4 hover:bg-white/10" aria-label="increase">
      <Plus size={14} />
    </button>
  </div>
);

export default QuantitySelector;
